exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alarm[data-v-5b70fdb0]{background:-webkit-gradient(linear,left bottom,left top,from(rgba(231,56,56,.01)),to(rgba(231,56,56,.01)));background:linear-gradient(0deg,rgba(231,56,56,.01),rgba(231,56,56,.01));border:2px solid #f72f2f;-webkit-box-shadow:1px 1px 50px 15px #e73838 inset;box-shadow:inset 1px 1px 50px 15px #e73838}", ""]);

// exports
